"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentReviewAssignmentSchema = exports.DocumentReviewStatusKeys = exports.DocumentReviewTabs = exports.REVIEWABLE_PERSONAL_DOCUMENTS = exports.DOCUMENT_REVIEW_TYPES = void 0;
var const_1 = require("./const");
exports.DOCUMENT_REVIEW_TYPES = ['tickets', 'personalDocuments', 'all'];
/** Only passports require admin/Sea Service review among personal documents */
exports.REVIEWABLE_PERSONAL_DOCUMENTS = ['66545f47ea632560cc0e58f7'];
exports.DocumentReviewTabs = [
    { id: const_1.DocumentStatus.UPLOADED, title: 'Pending Admin Review' },
    { id: const_1.DocumentStatus.UNDER_REVIEW, title: 'Pending Sea Service Approval' },
    { id: const_1.DocumentStatus.SIGHTED, title: 'Approved (Sighted)' },
];
exports.DocumentReviewStatusKeys = exports.DocumentReviewTabs.map(function (tab) { return tab.id; });
exports.DocumentReviewAssignmentSchema = {
    assignedAdminId: 'assignedAdminId',
    adminWorkflowStatus: 'adminWorkflowStatus',
};
//# sourceMappingURL=DocumentReview.js.map